/* Tomorrow Beyond — motion layer for the v2 home.
   1. Entrances: [data-reveal] elements get .is-in when they enter the viewport.
   2. Gallery loops: muted videos play only while on screen.
   3. Fan scene: four Human OS cards dealt onto a sticky stage, scrubbed by
      GSAP ScrollTrigger on Horizon's inner scroller (.page-wrapper).
   Reduced motion: entrances are instant (CSS), the fan is simply there. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Entrances ──────────────────────────────────────── */
  /* Inner pages: product cards, blog cards and article blocks enter too.
     Tagged from script so they stay visible when it does not run. */
  if (!document.body.classList.contains('template-index')) {
    document
      .querySelectorAll('.product-grid__item, .tb-blog-card, .tb-article > *')
      .forEach(function (el) { el.setAttribute('data-reveal', ''); });
  }
  var reveals = document.querySelectorAll('[data-reveal]');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ── 2. Gallery loops ──────────────────────────────────── */
  var loops = document.querySelectorAll('video[data-tb-loop], .tb-gallery__video');
  if (loops.length && 'IntersectionObserver' in window && !reduceMotion) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.3 });
    loops.forEach(function (v) { vio.observe(v); });
  }

  /* ── 3. Fan scene ──────────────────────────────────────── */
  var fan = document.querySelector('[data-tb-fan]');
  if (!fan) return;
  var cards = Array.prototype.slice.call(fan.querySelectorAll('.tb-fan__card'));
  var n = cards.length;
  if (!n) return;

  var SPACING = 250;
  var ROTATIONS = [-4, -1.5, 1.5, 4];

  /* final fan: n cards centred, SPACING apart */
  function restPositions(count) {
    var out = [];
    for (var i = 0; i < count; i++) {
      out.push((i - (count - 1) / 2) * SPACING);
    }
    return out;
  }

  function placeCard(card, x, y, r) {
    card.style.setProperty('--fan-x', x + 'px');
    card.style.setProperty('--fan-y', y + 'px');
    card.style.setProperty('--fan-r', r + 'deg');
  }

  function ease(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* progress 0..1 → card 0 alone at centre, then one more dealt per segment */
  function render(p) {
    var segments = n - 1;
    var seg = Math.min(Math.floor(p * segments), segments - 1);
    var local = segments ? ease(Math.min(Math.max(p * segments - seg, 0), 1)) : 1;
    var dealt = seg + 1;               /* cards fully on the table */
    var from = restPositions(dealt);
    var to = restPositions(dealt + 1);

    for (var i = 0; i < n; i++) {
      var r = ROTATIONS[i] || 0;
      if (i < dealt) {
        var x = from[i] + (to[i] - from[i]) * local;
        placeCard(cards[i], x, 0, r);
      } else if (i === dealt) {
        var yIn = (1 - local) * (window.innerHeight * 0.75);
        placeCard(cards[i], to[i], yIn, r * local);
      } else {
        placeCard(cards[i], 0, window.innerHeight, 0);
      }
    }
  }

  function restAll() {
    var rest = restPositions(n);
    for (var i = 0; i < n; i++) placeCard(cards[i], rest[i], 0, ROTATIONS[i] || 0);
  }

  var wide = window.matchMedia('(min-width: 1024px)').matches;
  if (reduceMotion || !wide || !window.gsap || !window.ScrollTrigger) {
    restAll();
    return;
  }

  /* scale the 1,090px fan on narrower desktops */
  function fitDeck() {
    var deck = fan.querySelector('.tb-fan__deck');
    /* the head owns a 380px column on the left (see tb-v2.css) */
    var avail = fan.clientWidth - 380 - 64;
    var scale = Math.min(1, avail / 1090);
    deck.style.transform = 'scale(' + scale + ')';
  }
  fitDeck();
  window.addEventListener('resize', fitDeck);

  window.gsap.registerPlugin(window.ScrollTrigger);
  fan.classList.add('is-live');
  render(0);

  window.ScrollTrigger.create({
    scroller: document.querySelector('.page-wrapper') || window,
    trigger: fan,
    start: 'top top',
    end: 'bottom bottom',
    scrub: 0.4,
    onUpdate: function (self) { render(self.progress); }
  });

  window.__tbFan = { render: render };

  window.addEventListener('load', function () { window.ScrollTrigger.refresh(); });
})();
